var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.75H10.5C10.09 14.75 9.75 14.41 9.75 14C9.75 13.59 10.09 13.25 10.5 13.25H13C15.62 13.25 17.75 11.12 17.75 8.5C17.75 5.88 15.62 3.75 13 3.75H8C5.38 3.75 3.25 5.88 3.25 8.5C3.25 9.6 3.64 10.67 4.34 11.52C4.6 11.84 4.56 12.31 4.24 12.58C3.92 12.84 3.45 12.8 3.18 12.48C2.26 11.36 1.75 9.95 1.75 8.5C1.75 5.05 4.55 2.25 8 2.25H13C16.45 2.25 19.25 5.05 19.25 8.5C19.25 11.95 16.45 14.75 13 14.75Z",
    fill: "#11A811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.75H12C8.55 21.75 5.75 18.95 5.75 15.5C5.75 12.05 8.55 9.25 12 9.25H14.5C14.91 9.25 15.25 9.59 15.25 10C15.25 10.41 14.91 10.75 14.5 10.75H12C9.38 10.75 7.25 12.88 7.25 15.5C7.25 18.12 9.38 20.25 12 20.25H17C19.62 20.25 21.75 18.12 21.75 15.5C21.75 14.4 21.36 13.33 20.66 12.48C20.4 12.16 20.44 11.69 20.76 11.42C21.08 11.15 21.55 11.2 21.82 11.52C22.75 12.64 23.26 14.05 23.26 15.5C23.25 18.95 20.45 21.75 17 21.75Z",
    fill: "#11A811"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7c6fcdcfe1910e775b1c1d276edc44de.svg";
export { ForwardRef as ReactComponent };